import { render, staticRenderFns } from "./TheDetalleFactura.vue?vue&type=template&id=1c58ab1b&scoped=true&"
import script from "./TheDetalleFactura.vue?vue&type=script&lang=js&"
export * from "./TheDetalleFactura.vue?vue&type=script&lang=js&"
import style0 from "./TheDetalleFactura.vue?vue&type=style&index=0&id=1c58ab1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c58ab1b",
  null
  
)

export default component.exports